import React from "react";
import Spinner from "../Spinner";
import NotificationCard from "../NotificationCard/NotificationCard";
import { NotificationCardProp } from "../NotificationCard/NotificationCard";
import "./LoadingCard.scss";

const LoadingCard: React.FC<NotificationCardProp> = ({
  title,
  subtitle,
  children,
  className,
  closeModal,
}) => {
  return (
    <NotificationCard
      icon={<Spinner size="small" />}
      title={title}
      subtitle={subtitle}
      className={`loading-card ${className}`}
      closeModal={closeModal}
      children={children}
    />
  );
};

export default LoadingCard;
